import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { User } from '../../models/User';
import { firestore } from './../../firebase/firebase';
import { Station } from './../../models/Station';

const GET_STATION_DETAILS = 'GET_STATION_DETAILS';
const USERS_STATION = 'USERS_STATION';

export interface GetStationAction {
  type: typeof GET_STATION_DETAILS;
  payload: {
    station: Station;
    users: User[];
  };
}
export interface UserStationAction {
  type: typeof USERS_STATION;
  payload: {
    users: User[];
  };
}

export type StationDetailActions = GetStationAction | UserStationAction;

const getStationDetailsAction = (
  station: Station,
  users: User[]
): GetStationAction => {
  return {
    type: GET_STATION_DETAILS,
    payload: {
      station,
      users,
    },
  };
};

export const getStationDetails = (id: string) => {
  return async (dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
    const snapshot = await firestore.collection('stations').doc(id).get();
    const name = snapshot.data()?.stationName;
    const address = snapshot.data()?.stationAddress;
    const postcode = snapshot.data()?.stationPostcode;
    const state = snapshot.data()?.stationState;
    const companyId = snapshot.data()?.companyId;
    const companyName = snapshot.data()?.companyName;

    const station = new Station(
      snapshot.id,
      name,
      address,
      postcode,
      state,
      companyId,
      companyName
    );

    const usersSnapshot = await firestore
      .collection('stations')
      .doc(id)
      .collection('users')
      .orderBy('timestamp', 'desc')
      .get();

    const users = usersSnapshot.docs.map(
      (doc) =>
        new User(
          doc.data().uid,
          doc.data().name,
          doc.data().icNumber,
          doc.data().contactNumber,
          undefined,
          doc.data().timestamp.toDate(),
          doc.data().temperature,
        )
    );

    dispatch(getStationDetailsAction(station, users));
  };
};
